"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('discardConversationsOption')(function discardConversationsOption(state) {
    var optionState = state.optionState;
    optionState.globalListViewType = null;
    optionState.conversationSortOrder = null;
    optionState.hideDeletedItems = null;
}));
//# sourceMappingURL=discardConversationsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-conversations-option/lib/actions/discardConversationsOption.js
// module id = 5079
// module chunks = 2